/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Cores} from '../../models/cores'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";

const url = '/cores'

const state = {
  all: [],
  allList: [],
  cores: new Cores(),
  filtro: new Filtro()
}

const getters = {
  listaAllCores: (state) => {
    return state.allList
  },

  listaCores: (state) => {
    return state.all
  },
  pegaCor: (state) => {
    return state.cores
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
  state.filtro.filters.addSearch(['descr'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {cores_id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('cores_id', cores_id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_COR', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', BaseDescSCH(perPage))
  },

  async setAllListCores({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
  },
  async setAllCores({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_CORES', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarCor({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.cores, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setCor({commit}, cores) {
    commit('SET_COR', cores)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_CORES(state, cores) {
    state.all = cores
  },
  SET_COR(state, cores) {
    state.cores = cores
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
